module.exports = __webpack_public_path__ + "static/media/Venmo.fa74816d.svg";